import CodeSnippet from '../CodeSnippet';

export default function IntegratePython({ apiUrl, tokenPlaceholder }) {
  const base = `${apiUrl || 'https://api.osrouter.dev'}/api/v1`;
  const code = `from openai import OpenAI

client = OpenAI(
    base_url="${base}",
    api_key="${tokenPlaceholder}",
)

response = client.chat.completions.create(
    model="claude-haiku-4.5",
    messages=[{"role": "user", "content": "Hello from os-router"}],
)

print(response.choices[0].message.content)`;

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Python SDK</h1>
      <p className="text-sm opacity-60 mb-6">
        Use the OpenAI Python SDK. Set the base URL and your os-router API key.
      </p>
      <CodeSnippet code={code} language="python" />
    </div>
  );
}
